import React, { useState } from 'react';
import api from '../utils/api';
import { X, Lock, AlertCircle, CheckCircle } from 'lucide-react';
import './PasswordChangePopover.css';

function PasswordChangePopover({ onClose, onSuccess }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  
  // Get current user email for Safari password manager
  const userEmail = JSON.parse(localStorage.getItem('user') || '{}').email || '';

  const validatePasswords = () => {
    if (!currentPassword) {
      return 'Kérem adja meg a jelenlegi jelszavát';
    }
    if (!newPassword) {
      return 'Kérem adja meg az új jelszót';
    }
    if (newPassword.length < 10) {
      return 'Az új jelszónak legalább 10 karakter hosszúnak kell lennie';
    }
    if (newPassword !== confirmPassword) {
      return 'Az új jelszavak nem egyeznek';
    }
    if (currentPassword === newPassword) {
      return 'Az új jelszó nem lehet azonos a jelenlegivel';
    }
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const validationError = validatePasswords();
    if (validationError) {
      setError(validationError);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await api.post(
        '/api/auth/change-password',
        {
          current_password: currentPassword,
          new_password: newPassword
        }
      );

      setSuccess(true);
      setTimeout(() => {
        if (onSuccess) onSuccess();
        onClose();
      }, 1500);
    } catch (err) {
      console.error('Password change error:', err);
      setError(err.response?.data?.detail || 'Jelszómódosítás sikertelen');
      setLoading(false);
    }
  };

  return (
    <div className="password-overlay" onClick={onClose}>
      <div className="password-popover" onClick={(e) => e.stopPropagation()}>
        <div className="password-header">
          <div className="password-title-section">
            <Lock size={24} className="password-icon" />
            <h2 className="password-title">Jelszómódosítás</h2>
          </div>
          <button className="close-button" onClick={onClose} type="button">
            <X size={20} />
          </button>
        </div>

        <div className="password-content">
          {success ? (
            <div className="success-state">
              <CheckCircle size={48} className="success-icon" />
              <p className="success-message">Jelszó sikeresen módosítva!</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} autoComplete="off">
              {/* Hidden username field for Safari password manager */}
              <input
                type="email"
                name="username"
                autoComplete="username"
                value={userEmail}
                readOnly
                style={{ display: 'none' }}
                tabIndex="-1"
              />
              
              {error && (
                <div className="error-message">
                  <AlertCircle size={16} />
                  <span>{error}</span>
                </div>
              )}

              <div className="form-group">
                <label htmlFor="currentPassword">Jelenlegi jelszó</label>
                <input
                  type="password"
                  id="currentPassword"
                  name="current-password"
                  autoComplete="current-password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  placeholder="Adja meg jelenlegi jelszavát"
                  disabled={loading}
                  autoFocus
                />
              </div>

              <div className="form-group">
                <label htmlFor="newPassword">Új jelszó</label>
                <input
                  type="password"
                  id="newPassword"
                  name="new-password"
                  autoComplete="new-password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Legalább 10 karakter"
                  disabled={loading}
                />
                <small className="field-hint">
                  A jelszónak legalább 10 karakter hosszúnak kell lennie
                </small>
              </div>

              <div className="form-group">
                <label htmlFor="confirmPassword">Új jelszó megerősítése</label>
                <input
                  type="password"
                  id="confirmPassword"
                  name="new-password-confirm"
                  autoComplete="new-password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Írja be újra az új jelszót"
                  disabled={loading}
                />
              </div>

              <div className="button-group">
                <button
                  type="button"
                  className="cancel-button"
                  onClick={onClose}
                  disabled={loading}
                >
                  Mégse
                </button>
                <button
                  type="submit"
                  className="submit-button"
                  disabled={loading}
                >
                  {loading ? 'Módosítás...' : 'Módosítás'}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default PasswordChangePopover;
